<template>
  <div class="page">
    <div style="display:none" v-title>忘记密码 - 唯丝普</div>
    <div class="forget-form">
      <div class="input-item">
        <i class="wsp-icon icon-mobile"></i>
        <input type="text" v-model="phone" placeholder="请输入手机号码" />
      </div>
      <div class="input-item">
        <i class="wsp-icon icon-pwd"></i>
        <input type="password" v-model="password" placeholder="请输入6位以上的新密码" />
      </div>
      <div class="input-item">
        <i class="wsp-icon icon-pwd-again"></i>
        <input type="password" v-model="rePassword" placeholder="请再次输入新密码" />
      </div>
      <div class="input-item">
        <i class="wsp-icon icon-code"></i>
        <div class="input-code">
          <input type="text" v-model="code" placeholder="请输入验证码" />
          <span class="input-code-btn" @click="getCode" :class="{'input-code-btn-active': hasSent}">{{codeText}}</span>
        </div>
      </div>
    </div>
    <div class="forget-btn" @click="toChange">提交</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { validateEmpty, validateTel } from '../utils/validator'
import md5 from 'js-md5'
export default {
  name: 'Forget',
  data () {
    return {
      hasSent: false,
      codeText: '获取验证码',
      phone: '',
      password: '',
      rePassword: '',
      time: 60,
      st: '',
      code: ''
    }
  },
  methods: {
    // 改变密码
    toChange () {
      if (validateEmpty(this.phone)) {
        Toast({
          message: '请输入手机号码！',
          duration: 1500
        })
        return
      }
      if (validateTel(this.phone)) {
        Toast({
          message: '请输入正确的手机号码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.password)) {
        Toast({
          message: '请输入密码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.rePassword)) {
        Toast({
          message: '请输入确认密码！',
          duration: 1500
        })
        return
      }
      if (this.password !== this.rePassword) {
        Toast({
          message: '两次密码不相同！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.code)) {
        Toast({
          message: '请输入验证码！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'
      let sign = md5(secret + appkey + formet + md5(this.password) + md5(this.rePassword) + this.phone + serial + this.code + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        phone: this.phone,
        smscode: this.code,
        password: md5(this.password),
        password2: md5(this.rePassword)
      }
      // 注册
      this.$axios.get('/Index/Doctor/resetPassword', { params: params }).then((response) => {
        if (response.data.code === 1000) {
          Toast({
            message: '修改密码成功！',
            duration: 1500
          })
          setTimeout(() => {
            this.$router.replace({
              path: '/Doctor/Login',
              query: {
                comcode: this.$route.query.comcode,
                openid: this.$route.query.openid
              }
            })
          }, 2000)
        } else {
          Toast({
            message: '修改密码失败！',
            duration: 1500
          })
        }
      }).catch(function () {})
    },
    // 获取验证码
    getCode () {
      if (this.hasSent) {
        return
      }
      if (validateEmpty(this.phone)) {
        Toast({
          message: '请输入手机号码！',
          duration: 1500
        })
        return
      }
      if (validateTel(this.phone)) {
        Toast({
          message: '请输入正确的手机号码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.password)) {
        Toast({
          message: '请输入密码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.rePassword)) {
        Toast({
          message: '请输入确认密码！',
          duration: 1500
        })
        return
      }
      if (this.password !== this.rePassword) {
        Toast({
          message: '两次密码不相同！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'
      let sign = md5(secret + appkey + formet + this.phone + serial + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        phone: this.phone
      }
      // 用户信息
      this.$axios.get('/Index/Doctor/SmsCode', { params: params }).then((response) => {
        this.hasSent = true
        clearInterval(this.st)
        this.st = setInterval(() => {
          if (this.time > 1) {
            this.time--
            this.codeText = this.time + 's'
          } else {
            this.time = 60
            this.codeText = '获取验证码'
            this.hasSent = false
            clearInterval(this.st)
          }
        }, 1000)
      }).catch(function () {})
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  margin 0 auto
  width 720px
.forget-form
  width 100%
  padding 92px 30px 60px 30px
  .input-item
    margin-bottom 50px
  input
    border-bottom: 1px solid #eaeaea; /*no*/
    width 591px
    height 46px
    margin-left 20px
    // padding-bottom 10px
    line-height 46px
    font-size: 26px; /*px*/
    background-color transparent
    color #333
  .input-code
    position relative
    display inline-block
    width 611px
    height 46px
    line-height 46px
    font-size: 29px; /*px*/
    position relative
    color #666
  .input-code-btn
    position absolute
    top -30px
    right 0
    display inline-block
    width 210px
    height 68px
    line-height 68px
    color #666666
    text-align center
    font-size: 25px; /*px*/
    border-radius 5px
    border: 1px solid #999899; /*no*/
  .input-code-btn-active
    border none
    color #ffffff
    background-image url('../assets/images/icon-code-bg.png')
    background-size 210px 68px
.icon-mobile
  display inline-block
  width 35px
  height 46px
  background-image url('../assets/images/icon-mobile.png')
.icon-pwd
  display inline-block
  width 35px
  height 40px
  background-image url('../assets/images/icon-pwd.png')
.icon-pwd-again
  display inline-block
  width 35px
  height 40px
  background-image url('../assets/images/icon-pwd-again.png')
.icon-code
  display inline-block
  width 35px
  height 40px
  background-image url('../assets/images/icon-code.png')
.forget-btn
  margin 0 auto
  width 664px
  height 86px
  line-height 86px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-color #c4c4c4
  border-radius 5px
  background-image url('../assets/images/l-btn.png')
  background-size 664px 86px
  background-repeat no-repeat
  font-weight 300
</style>



// WEBPACK FOOTER //
// src/pages/Forget.vue